import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import * as React from 'react';
import { type ReactElement } from 'react';

export interface DialogHeaderProps {
    title: string;
    onClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Dialog = ({ title, onClose: onCloseClick }: DialogHeaderProps): ReactElement => {    
    return (
        <Box
            sx={(theme) => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                overflow: 'hidden',
                px: 3,
                py: 2,
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                boxShadow: theme.shadows[4],
            })}
        >
            <Typography
                id="dialog-title"
                variant="h6"
                fontWeight="700"
                noWrap
                style={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}
                component="div">{title}</Typography>
            <IconButton edge="end" color="inherit" onClick={onCloseClick} aria-label="close">
                <CloseIcon />
            </IconButton>
        </Box>
    );
}

export default Dialog;
